import getApi from '../../api/apisauceConfig'
import { deserializePatientResponse } from './mapper/patients.mapper'
import { ApiPatientResource } from './mapper/patients.model'

export const mergePatients = (patientId: number, patientToMergeId: number) =>
  getApi()
    .post<ApiPatientResource>(`patients/${patientId}/merge`, { patientId: patientToMergeId })
    .then(deserializePatientResponse)
